/* Preserve the ONE cart request owned by Dawn/Globo. Only configured variants are adapted. */
(() => {
  'use strict';
  if(window.RRTCPrintCart)return;
  const owners=new Set(),baseFetch=window.fetch,cartReads=new WeakMap();
  const cartPath=/\/cart\/add(?:\.js)?$/;
  const append=(fd,name,value)=>{
    if(value instanceof Blob)fd.append(name,value,value.name||'file');
    else if(Array.isArray(value))value.forEach((v,i)=>append(fd,`${name}[${i}]`,v));
    else if(value&&typeof value==='object')Object.entries(value).forEach(([k,v])=>append(fd,`${name}[${k}]`,v));
    else if(value!==null&&value!==undefined)fd.append(name,String(value));
  };
  const properties=(fd,prefix)=>Object.fromEntries([...fd].filter(([k])=>k.startsWith(prefix+'properties[')).map(([k,v])=>[k.slice((prefix+'properties[').length,-1),v]));
  function unpack(body){
    if(body instanceof FormData){
      const indices=[...new Set([...body.keys()].map(k=>k.match(/^items\[(\d+)\]\[id\]$/)?.[1]).filter(v=>v!==undefined))];
      return {fd:body,items:indices.length?indices.map(i=>({id:body.get(`items[${i}][id]`),quantity:body.get(`items[${i}][quantity]`)||1,properties:properties(body,`items[${i}][`),index:i})): [{id:body.get('id'),quantity:body.get('quantity')||1,properties:properties(body,''),index:null}]};
    }
    if(typeof body==='string'){
      const json=JSON.parse(body),fd=new FormData();Object.entries(json).forEach(([k,v])=>append(fd,k,v));
      return {fd,items:json.items?json.items.map((item,i)=>({...item,index:i})):[{...json,index:null}]};
    }
    throw Error('error_transport');
  }
  // Shopify's nested items syntax closes the item bracket before the property.
  const propKey=(index,key)=>index===null?`properties[${key}]`:`items[${index}][properties][${key}]`;
  function formItems(fd){
    const indices=[...new Set([...fd.keys()].map(k=>k.match(/^items\[(\d+)\]\[id\]$/)?.[1]).filter(v=>v!==undefined))];
    return indices.length?indices.map(index=>({index,id:fd.get(`items[${index}][id]`),quantity:fd.get(`items[${index}][quantity]`)||1,properties:Object.fromEntries([...fd].filter(([k])=>k.startsWith(`items[${index}][properties][`)).map(([k,v])=>[k.slice(`items[${index}][properties][`.length,-1),v]))})): [{index:null,id:fd.get('id'),quantity:fd.get('quantity')||1,properties:properties(fd,'')}];
  }
  async function reconcile(cp,snapshot){
    try{
      const response=await baseFetch.call(window,(window.Shopify?.routes?.root||'/')+'cart.js',{credentials:'same-origin',cache:'no-store'});
      if(!response.ok)return false;
      const cart=await response.json(),lines=cart.items.filter(i=>i.properties?.['Design ID']===snapshot.id);
      if(lines.length===1&&String(lines[0].variant_id)===snapshot.variant&&Number(lines[0].quantity)===snapshot.quantity&&hasFiles(lines[0])){cp.cartResult('added',snapshot);return true;}
    }catch(_){}
    return false;
  }
  const hasFiles=item=>['Your image','_Print file'].every(k=>typeof item.properties?.[k]==='string'&&/^https:\/\//.test(item.properties[k]));
  async function refresh(cp){
    const snapshot=cp.intent;
    // Never unlock a request still in flight or one whose outcome is uncertain.
    if(!owners.has(cp) || snapshot?.phase!=='added')return false;
    const read={};cartReads.set(cp,read);
    try{
      const response=await baseFetch.call(window,(window.Shopify?.routes?.root||'/')+'cart.js',{credentials:'same-origin',cache:'no-store'});
      if(!response.ok)return false;
      const cart=await response.json();
      if(!owners.has(cp) || cartReads.get(cp)!==read)return false;
      return cp.cartUpdated(cart,snapshot);
    }catch(_){return false;}
  }
  async function wrapped(input,init){
    const url=new URL(input instanceof Request?input.url:input,location.href),method=(init?.method||(input instanceof Request?input.method:'GET')).toUpperCase();
    if(!owners.size||url.origin!==location.origin||!cartPath.test(url.pathname)||method!=='POST')return baseFetch.call(this,input,init);
    let body=init?.body;
    if(body===undefined&&input instanceof Request){const type=input.headers.get('content-type')||'';body=type.includes('multipart/form-data')?await input.clone().formData():await input.clone().text();}
    let decoded;
    try{decoded=unpack(body);decoded.items=formItems(decoded.fd);}catch(e){for(const cp of owners)if(cp.intent)cp.cartResult('error',cp.intent);throw Error('error_transport');}
    const matches=[];
    for(const item of decoded.items)for(const cp of owners)if(cp.config.variants.some(v=>String(v.id)===String(item.id)))matches.push({cp,item});
    if(!matches.length)return baseFetch.call(this,input,init);
    if(matches.length!==1)throw Error('error_transport');
    const {cp,item}=matches[0],snapshot=cp.intent;
    if(!snapshot||snapshot.phase!=='intent'||snapshot.attempt!==item.properties?.['_Print attempt']||snapshot.id!==item.properties?.['Design ID']||snapshot.id!==cp.spec?.design_id||snapshot.generation!==cp.generation||snapshot.variant!==String(item.id)||!cp.valid()){
      cp.cartResult(['sending','uncertain','added'].includes(snapshot?.phase)?'busy':'error',snapshot);throw Error('error_transport');
    }
    snapshot.quantity=Number(item.quantity);
    if(!Number.isSafeInteger(snapshot.quantity)||snapshot.quantity<1)throw Error('error_transport');
    for(const [key,value] of Object.entries(cp.cartProperties())){
      const name=propKey(item.index,key);if(value instanceof File)decoded.fd.set(name,value,value.name);else decoded.fd.set(name,value);
    }
    if(!cp.uploads?.original||!cp.uploads?.print)throw Error('error_transport');
    const headers=new Headers(init?.headers||(input instanceof Request?input.headers:undefined));headers.delete('content-type');
    clearTimeout(cp.intentTimer);snapshot.phase='sending';cp.updateLock();
    let response;
    try{
      response=await baseFetch.call(this,input,{...init,method:'POST',body:decoded.fd,headers});
      if(response.status>=400&&response.status<500){cp.cartResult('error',snapshot);return response;}
      if(!response.ok)throw Error('error_cart');
      const result=await response.clone().json(),items=result.items||[result],line=items.find(i=>i.properties?.['Design ID']===snapshot.id);
      if(!line||!hasFiles(line))throw Error('error_cart');
      cp.cartResult('added',snapshot);return response;
    }catch(e){
      if(!await reconcile(cp,snapshot))cp.cartResult('uncertain',snapshot);
      // Never repeat an uncertain POST. Customer can inspect the cart via recovery link.
      throw e;
    }
  }
  window.fetch=wrapped;
  window.RRTCPrintCart={register(cp){owners.add(cp);return()=>{owners.delete(cp);cartReads.delete(cp);};},refresh,isInstalled(){return window.fetch===wrapped;}};
})();
